export const LinkRateSpecificAmounType = [
    { label: 'Amount', value: 'amount' },
    { label: 'Percentage', value: 'percent' },
];